import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { confirmDialog } from 'primereact/confirmdialog';
import { useSocket } from '../../contexts/socket/SocketContext';
import { useAccount } from '../../contexts/account/AccountContexts';
import useDataLayer, { IPurchaseDataLayer } from '../global/UseDataLayer';
import { getAccount } from '../../services/account/AccountService';

export const useAccountSubscriptionSocket = () => {
  const { t } = useTranslation();
  const socket = useSocket();
  const { accountResponse, refetchData } = useAccount();
  const { pushDataLayer } = useDataLayer();

  useEffect(() => {
    if (!socket || !accountResponse) return;

    const handleSubscriptionUpdate = async (data: any) => {
      if (!data.refresh) return;

      const { accountId, userId } = accountResponse;

      if (
        data.additionalData &&
        data.additionalData.id &&
        data.additionalData.price &&
        accountId &&
        userId
      ) {
        pushDataLayer<IPurchaseDataLayer>({
          event: 'purchase',
          transaction_id: data.additionalData.id,
          value: data.additionalData.price,
          account_id: accountId.toString(),
          user_id: userId.toString(),
          currency: 'USD',
          items: [
            {
              item_id: data.additionalData.id,
              item_name: `Subscription ID ${data.additionalData.id}`,
              price: data.additionalData.price,
              quantity: 1,
            },
          ],
        });
      }

      const freshAccountData = await getAccount();
      refetchData();

      if (freshAccountData.createdMonitorCount > freshAccountData.maxMonitorCount) {
        confirmDialog({
          message: t('limitExceededMessage'),
          header: t('information'),
          defaultFocus: 'accept',
          acceptLabel: t('confirm'),
          rejectClassName: 'hide',
        });
      }
    };

    console.log('[AccountSubscription] Setting up listener');
    socket.on('subscription-update', handleSubscriptionUpdate);

    return () => {
      console.log('[AccountSubscription] Cleaning up listener');
      socket.off('subscription-update', handleSubscriptionUpdate);
    };
  }, [socket, accountResponse, refetchData, pushDataLayer, t]);
};
